import styled from "styled-components";
import stylesBlocks from "./core/stylesBuilder";

const Box = styled.div`
  max-width: ${(props) => props.w ? props.w + "px" : "auto"};
  ${stylesBlocks}
`;

export default Box;
